import { render, staticRenderFns } from "./WatsonDialog.vue?vue&type=template&id=2ba03f2c&scoped=true&"
import script from "./WatsonDialog.vue?vue&type=script&lang=js&"
export * from "./WatsonDialog.vue?vue&type=script&lang=js&"
import style0 from "./WatsonDialog.vue?vue&type=style&index=0&id=2ba03f2c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba03f2c",
  null
  
)

export default component.exports